import z from "zod";

export const terminalPlanningNotesSchema = z.object({
	notes: z.string(),
	updateLastContactTime: z.boolean(),
});

export type TerminalPlanningNotesSchemaInput = z.input<typeof terminalPlanningNotesSchema>;
export type TerminalPlanningNotesSchemaOutput = z.output<typeof terminalPlanningNotesSchema>;
